import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/front/eva-ai-web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/front/eva-ai-web/node_modules/next-sanity/dist/visual-editing/client-component/index.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/builds/front/eva-ai-web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["DisableDraftMode"] */ "/builds/front/eva-ai-web/src/components/SanityVisualEditing/DisableDraftMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoresLayout"] */ "/builds/front/eva-ai-web/src/layouts/stores/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/builds/front/eva-ai-web/src/shared/services/metrics/web-vitals.ts");
